// API Configuration
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

// Category Icons mapping (for goals)
import { Eye, Zap, Brain, Target } from "lucide-react";
export const categoryIcons = { technical: Eye, physical: Zap, tactical: Brain, mental: Target };

// Dummy coaches data (for display purposes)
export const dummyCoaches = [
  {
    id: '1',
    name: 'Sarah Johnson',
    specialty: 'Technical Skills',
    experience: '12 years',
    rating: 4.9,
    reviews: 127,
    image: 'https://images.unsplash.com/photo-1594381898411-846e7d193883?w=200&h=200&fit=crop',
    bio: 'Former professional player specializing in ball control and passing technique.',
    availability: 'Mon, Wed, Fri',
    price: 75
  },
  {
    id: '2',
    name: 'Marcus Chen',
    specialty: 'Physical Conditioning',
    experience: '8 years',
    rating: 4.8,
    reviews: 89,
    image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=200&h=200&fit=crop',
    bio: 'Certified strength and conditioning coach with sports science background.',
    availability: 'Tue, Thu, Sat',
    price: 65
  },
  {
    id: '3',
    name: 'Emma Williams',
    specialty: 'Tactical Analysis',
    experience: '15 years',
    rating: 4.95,
    reviews: 203,
    image: 'https://images.unsplash.com/photo-1548690312-e3b507d8c110?w=200&h=200&fit=crop',
    bio: 'UEFA licensed coach with experience at top academies across Europe.',
    availability: 'Mon-Fri',
    price: 95
  },
  {
    id: '4',
    name: 'David Martinez',
    specialty: 'Mental Performance',
    experience: '10 years',
    rating: 4.7,
    reviews: 156,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
    bio: 'Sports psychologist helping athletes achieve peak mental performance.',
    availability: 'Wed, Sat, Sun',
    price: 85
  }
];

// Helper function for greetings
export const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
};
